// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f3dd2b7e","698":"1d5cf914","815":"e2be70c4","843":"cd5205bd","870":"728c4403","893":"106e08db"}[chunkId] + ".chunk.js";
};